import { Subject } from 'rxjs';
import { QueovalBase, FileModel } from '../global';
import { ColDef } from 'ag-grid-community';

export class CustomgridModel extends QueovalBase {
  public cgParameters: CustomgridParam;
  public GridXml: CustomgridXml;
  public FileModel: FileModel;
  public ConfigGrid: CustomgridConfig;

  constructor() {
    super();
    this.cgParameters = new CustomgridParam();
    this.GridXml = new CustomgridXml();
    this.FileModel = new FileModel();
    this.ConfigGrid = new CustomgridConfig();
  }
}

export class CustomgridConfig {
  public Name: string;
  public parameters: Array<ColDef>;
}

export class CustomgridXml {
  public titre: string;
  // Liste des boutons disponibles
  public modeUpdate: boolean;
  public modeDelete: boolean;
  public modeRecherche: boolean;
  public modeCreate: boolean;
  public modeOpen: boolean;
  public rechercheApprox: boolean;

  // Options de la grid
  public enableFilter: boolean;
  public enableColResize: boolean;
  public enableSorting: boolean;
  public pagination: boolean;
  public paginationAutoPageSize: boolean;
  public paginationPageSize: number;
  public showToolPanel: boolean;
  public enableStatusBar: boolean;
  public rowSelection: string;
  public rowGroupPanelShow: boolean;
  public sideBar: boolean;
  public enableCharts: boolean;

  // If grouping, set to the number of levels to expand by default, e.g. 0 for none, 1 for first level only, etc. Set to -1 to expand everything. See Removing Single Children.
  public groupDefaultExpanded: string;
  public groupIncludeFooter: boolean;
  public groupUseEntireRow: boolean;
  public groupIncludeTotalFooter: boolean;
  public groupHideOpenParents: boolean;

  public showOpenedGroup: boolean;


  public rowHeight: number;
  public domLayout: string;

  public customHeight: number;
  public adaptHeight: boolean;

  public columnDefs: CustomgridColumnDefs[];
  public rowData: CustomgridSQL;
  public rowFilter: CustomgridSQL;
}

export class CustomgridParam {
  constructor() {
    this.ShowContextColumn = true;
  }
  // Mode de l'action sur la grid
  public Mode: string;
  // Nom de la grid
  public FileName: string;
  // Indique si la grid est destinee au dashboard
  public IsDashboard: boolean;

  // Infos pour une grid automatique de BO fils
  public IdRelation: string;
  public IdDonnee: string;
  public IdDonneeParent: string;
  public Origine: string;
  public IdBO: string;
  public IdBOParent: string;
  public CompleteJoin: string;
  public CompleteWhere: string;
  public CompleteOrderBy: string;
  public CompleteWhereApprox: string;
  public CompleteHaving: string;
  public InputData: string;
  public IsRelationReel: boolean;
  public modeRecherche: boolean;
  public rechercheApprox: boolean;
  public ShowContextColumn: boolean;

  // Information sur les actions possibles
  public ShowSaveButton: boolean;
  public ShowRemoveButton: boolean;
  public ShowCreateButton: boolean;
  public ShowImportButton: boolean;

  // Resultat
  public Result: string;
  public Message: string;

  public isEdition: boolean;
  public isDataLoaded: boolean;
}

export class CustomgridColumnDefs {

  //ajout car non present verifier si erreur
  public codeName: boolean;
  public codeTooltip: string;
  public rowGroup: boolean;
  public enableRowGroup: boolean;
  public showRowGroupBool: boolean;
  public cellRenderer: string;
  public valueGetter: string;
  public filter: boolean;
  public aggFunc: string;
  public chartDataType: string;
  public isCustomComponent: boolean;

  

  public showDashBoard: boolean;
  public headerName: string;
  public headerTooltip: string;
  public field: string;
  public fieldselect: string;
  public showRowGroup: any;
  public rowGroupIndex: number;
  public enablePivot: boolean;
  public pivot: boolean;
  public width: number;
  public cellStyle: any;
  public cellClass: any;
  public minWidth: number;
  public maxWidth: number;
  public editable: boolean;
  public pinned: string;
  public autoHeight: boolean;
  public headerCheckboxSelection: boolean;
  public headerCheckboxSelectionFilteredOnly: boolean;
  public checkboxSelection: boolean;
  public lockPinned: boolean;
  public lockPosition: boolean;
  public lockVisible: boolean;
  public headerClass: string;
  public hide: boolean;
  public cellEditor: string;
  public type: string;
  public footerField: string;
  public cellRendererFrameworkObject: CellRendererFrameworkObject;
  public cellRendererParams: CellRendererParams;

  public comparator: () => number;
}


export class CellRendererParams {
  public footerValueGetter: string;
}

export class CellRendererFrameworkObject {
  public type: string;
  public parameter: string;
  public display: string;
  public idBo: string;
  public idRelation: string;
  public idDonneePere: string;
  public rowGroupIndex: string;
}

export class CustomgridSQL {
  public _strTextSql: string;
  public requete: string;
  public data: any;
}

export class CustomgridSortAndFilter {
  // Nom de la customgrid
  public key: string;
  // Filtres 
  public filters: { [key: string]: any };
  // Tris
  public sorts: { [key: string]: any };

  constructor(key: string) {
    this.key = key;
  }
}

export class CustomgridObservableParam {
  // Nom de la customgrid
  public key: string;
  // Param
  public param: Subject<any>;
 
  constructor(key: string) {
    this.key = key;
    this.param = new Subject<any>();
  }
}
